export default "__VITE_ASSET__DhRP4uRK__"